module.exports = __webpack_public_path__ + "img/01-homeMobile2.95d5e741.png";